import { RadioButtonProps } from '../../shared/modules/ui-kit/models/interfaces';

export const ON_OFF_GROUP: RadioButtonProps[] = [
  { viewValue: 'On', value: true },
  { viewValue: 'Off', value: false },
];
